export type SnoozeReason =
  | 'ALREADY_HANDLED'
  | 'NOT_RELEVANT'
  | 'WILL_ACTION_LATER'
  | 'NEED_MORE_INFO'
  | 'OTHER';

export const SNOOZE_REASONS: { value: SnoozeReason; label: string }[] = [
  { value: 'ALREADY_HANDLED', label: 'Already handled' },
  { value: 'NOT_RELEVANT', label: 'Not relevant' },
  { value: 'WILL_ACTION_LATER', label: 'Will action later' },
  { value: 'NEED_MORE_INFO', label: 'Need more info' },
  { value: 'OTHER', label: 'Other' },
];

export const SNOOZE_DURATIONS: { value: string; label: string }[] = [
  { value: '1', label: '1 day' },
  { value: '3', label: '3 days' },
  { value: '7', label: '7 days' },
  { value: '30', label: '30 days' },
];

export const DEFAULT_SNOOZE_DAYS = '7';
